import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { AuthStore } from '@store';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appForCommercialUser]',
  standalone: true,
})
export class ForCommercialUserDirective implements OnInit, OnDestroy {
  @Input() appForCommercialUser: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authStore.isCommercialUser$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isCommercialUser) => {
        if (this.appForCommercialUser) {
          this.updateView(isCommercialUser);
        } else {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateView(isCommercialUser: boolean): void {
    this.viewContainer.clear();
    if (isCommercialUser && this.appForCommercialUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (!isCommercialUser && !this.appForCommercialUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    this.cdr.detectChanges();
  }
}
